<template>
    <van-popup v-model="showPayment" round :close-on-click-overlay="false" position="bottom" style="height:400px;">
        <div class="popup-title">付款</div>
        <van-skeleton :loading="loading" :row="10" style="margin:30px 2px;">
          <div class="payment-amount">
              <span class='payment-amount-symbol'>￥</span>
              <span class='payment-amount-big-font'>{{ payAmountFmts[0] }}</span>
              <span class='payment-amount-small-font'>.{{ payAmountFmts[1] }}</span>
          </div>
          <div v-if="payStatus == -1" >
            <van-radio-group value="1">
              <van-cell-group>
                <van-cell title="微信" clickable size="large">
                  <van-radio slot="right-icon" name="1" checked-color="#07c160"/>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
          <div v-else style="text-align:center;">
              <van-loading v-if="payStatus == 0" color="#1989fa" size="68px" vertical ></van-loading>
              <van-icon v-if="payStatus == 1"  name="passed" color="green" size="72px" ></van-icon>
              <van-icon v-if="payStatus == 2"  name="warning-o" color="red" size="72px" ></van-icon>
              <van-icon v-if="payStatus == 3"  name="close" color="red" size="72px" ></van-icon>
              <div v-if="payStatus == 3 || payStatus == 1 " style="margin-top:8px;">{{payResult}}</div>
          </div>
          <div v-if="payStatus == -1" class="bts-bottom" >
              <van-row gutter="20">
                  <van-col span="12" >
                  <van-button round block @click="doCancel"  >取消</van-button>
                  </van-col>
                  <van-col span="12">
                  <van-button round block type="danger" @click="doPay"  >支付</van-button>
                  </van-col>
              </van-row>
          </div>
          <div v-if="payStatus == 1" class="bts-bottom" >
            <van-button round block type="danger" @click="doOk" >返回</van-button>
          </div>
          <div v-if="payStatus == 3" class="bts-bottom" >
              <van-row gutter="20">
                  <van-col span="12" >
                      <van-button round block @click="doCancel"  >取消</van-button>
                  </van-col>
                  <van-col span="12">
                      <van-button round block type="danger" @click="toRepay"  >重新支付</van-button>
                  </van-col>
              </van-row>
          </div>
        </van-skeleton>
    </van-popup>
</template>

<script>
import { RadioGroup, Radio, CellGroup, Field, Cell, Tag, Popup, Row, Col, Button, Icon, Loading, Skeleton, Dialog} from 'vant';
// import wx from "weixin-jsapi"
import {parsePrice} from '@/utils/utils'
import request from '@/utils/request'
export default {
  components: {
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Loading.name]: Loading,
    [Skeleton.name]: Skeleton,
    [Dialog.name]: Dialog
  },
  data() {
    return {
        showPayment: false,
        loading: false,
        orderId: '',
        payAmount: 0,
        payAmountFmts: [],
        payStatus: -1,
        payResult: ''
    };
  },
  methods: {
    show(orderId, payAmount){
        this.loading = true
        this.showPayment = true
        this.orderId = orderId
        this.payAmount = payAmount
        this.payStatus = -1
        this.payResult = ''
        this.payAmountFmts = parsePrice(payAmount)
        this.loading = false
    },
    doPay(){
      this.payStatus = 0
      request({
        url: `/wxpubapis/order/pay/${this.orderId}`,
        method: "POST"
      }).then(({data}) => {
        this._calWeixinPay(data)
      }).catch(() => {
        this.payStatus = 3
        this.payResult = '付款失败'
      })
    },
    _calWeixinPay(wxPayParam){
        // console.log(wxPayParam)
        let that = this
        if (typeof window.WeixinJSBridge == 'undefined') {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady(wxPayParam), false)
          }else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady(wxPayParam))
            document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady(wxPayParam))
          }
        } else {
          that.onBridgeReady(wxPayParam)
        }
    },
    onBridgeReady (wxPayParam) {
      let that = this
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest', 
        {
          appId: wxPayParam.appId, // 公众号名称，由商户传入
          timeStamp: wxPayParam.timeStamp, // 时间戳，自1970年以来的秒数
          nonceStr: wxPayParam.nonceStr, // 随机串
          package: wxPayParam.package,
          signType: wxPayParam.signType, // 微信签名方式：
          paySign: wxPayParam.paySign // 微信签名
        }, 
        function (res) {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {//支付成功
            that.payStatus = 1
            that.payResult = '付款成功'
          }else if (res.err_msg === 'get_brand_wcpay_request:cancel') {//取消支付
            that.payStatus = 3
            that.payResult = '已取消支付'
          } else {
            that.payStatus = 3
            that.payResult = '付款失败'       
          }
        }  
      )
    },
    doCancel(){
      this.showPayment = false
      this.$emit('payCancel')
    },
    toRepay(){
      // this.payStatus = -1
      // this.payResult = ''
      this.doPay()
    },
    doOk(){
      this.showPayment = false
      this.$emit('success')
    }
  }
};
</script>

<style lang="less" >
  .payment-amount {
    margin-top: 15px;
    margin-bottom: 20px;
    text-align: center;
    font-weight: bold;
  }

  .payment-amount-symbol {
    font-size: 32rpx;
  }

  .payment-amount-big-font {
    font-size: 48rpx;
  }

  .payment-amount-small-font {
    font-size: 32rpx;
  }
</style>
